export interface ActiveUserShape {
  status?: string | null;
  deletedAt?: string | null;
}

export function isActiveUser(user: ActiveUserShape | null | undefined): boolean {
  return !!user && user.status === 'ACTIVE' && user.deletedAt == null;
}
